module.exports = __webpack_public_path__ + "static/00007.76f1ac38.jpg";